import BatchImageUploader from "@/components/hashedBulkUpload";
import React, { useState} from 'react';

function UploadResized() {
  const [uploadConfig] = useState({
    imageKind: "resized",
    directory: "resized"
  });

  return (
    <BatchImageUploader 
      imageKind={uploadConfig.imageKind}
      directory={uploadConfig.directory}
    />
  );
}

export default UploadResized;